import { useState } from "react";

const STORAGE_KEY = "immozwerg-favoriten";

/** Persistente Merkliste für Immobilien, bewusst analog zu Blog-Favoriten. */
export function useImmobilienFavoriten() {
  const [favoriten, setFavoriten] = useState<string[]>(() => {
    if (typeof window === "undefined") return [];
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  const toggle = (id: string) => {
    setFavoriten(previous => {
      const next = previous.includes(id)
        ? previous.filter(value => value !== id)
        : [...previous, id];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return { favoriten, toggle, istFavorit: (id: string) => favoriten.includes(id) };
}
